import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=683f217b&scoped=true&"
import script from "./ChatItem.vue?vue&type=script&lang=js&"
export * from "./ChatItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatItem.vue?vue&type=style&index=0&id=683f217b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683f217b",
  null
  
)

export default component.exports